import { useCallback } from "react"
import { DashBoardCondition } from "features/dashBoard/types"
import { useSunburstGraphOption } from "./options"
import { SunburstNode, useSunburstGraphModel } from "./model"

type useSunburstGraphEventsProps<T> = {
	graphOption: ReturnType<typeof useSunburstGraphOption<T>>
	graphData: ReturnType<typeof useSunburstGraphModel<T>>
	onChangeCondition: (
    axisKey?: string,
    changed?: DashBoardCondition,
    toggle?: boolean
  ) => void
}
export const useSunburstGraphEvents = <T,>({
	graphOption: {
		axisDef
	},
	graphData,
	onChangeCondition
}: useSunburstGraphEventsProps<T>) => {
  const onSelChanged = useCallback(
    (params: {
      selected?: [{ dataIndex: number[] }]
    }) => {
      if (!graphData || !axisDef?.key) return

      let selectedNode: SunburstNode | null = null
      const selected = params?.selected
      if (selected && selected.length > 0) {
        const dataIndex = selected[0].dataIndex
        if (dataIndex && dataIndex.length > 0) {
          const currentIndex = dataIndex[0]
          selectedNode = graphData.indexData[currentIndex - 1] ?? null
        }
      }
      onChangeCondition(
        axisDef.key,
        selectedNode
          ? selectedNode.children
            ? {
                code: selectedNode.children.map((it) => it.code),
                label: selectedNode.name,
              }
            : {
                code: [selectedNode.code],
                label: selectedNode.name,
              }
          : undefined
      )
    },
    [graphData, axisDef, onChangeCondition]
  )
	return {
		selectchanged: onSelChanged
	}
}